import { Modal } from "antd";

const formatUnitLabel = (unit) =>
  `${unit.building_unit?.street || ""} ${unit.building_unit?.house_number || ""}`;

const getUnique = (units, key) =>
  Array.from(new Set(units.map(u => u?.[key]?.id || u?.[key]).filter(Boolean)));

export const validators = {
  requireOriginalPartner(units) {
    if (units.some(u => !u?.partner_id)) {
      return { key: "schedules.validation.missingOriginalPartner" };
    }
  },
  requireOriginalRrule(units) {
    if (units.some(u => !u.rrule)) {
      return { key: "schedules.validation.missingOriginalRrule" };
    }
  },
  onePartnerOnly(units) {
    if (getUnique(units, "partner").length > 1) {
      return { key: "schedules.selectUnitsOfOnePartner" };
    }
  },
  oneSubstitutePartnerOnly(units) {
    if (getUnique(units, "substitute_partner_id").length > 1) {
      return { key: "schedules.validation.selectUnitsOfOneNewPartner" };
    }
  },
  oneCityBranchOnly(units) {
    if (getUnique(units, "city_branch_id").length > 1) {
      return { key: "schedules.validation.selectUnitsOfOneCityBranch" };
    }
  },
  requireSubstitutePartners(units) {
    const missing = units.filter(u => !u.substitute_partner);
    if (missing.length) {
      return {
        key: "schedules.missingSubstitutePartner",
        items: missing,
        formatter: formatUnitLabel,
      };
    }
  },
};

const showError = (t, { key, items, formatter }) => {
  Modal.error({
    title: t("common.error"),
    content: items?.length
      ? `${t(key)}: ${items.map(formatter).join(", ")}`
      : t(key),
  });
};

export const validateSelectedUnits = (units, t, { exclude = [] } = {}) => {
  for (const [id, rule] of Object.entries(validators)) {
    if (exclude.includes(id)) continue;
    const result = rule(units);
    if (result) {
      showError(t, result);
      return { isValid: false };
    }
  }
  return { isValid: true };
};
